import React, { useContext, useState } from 'react';
import { SecondaryButton, TextBox } from '../../../../Core/FormInput';
import { Grid, InputLabel } from '@material-ui/core';
import { postTCard_CheckIn } from '../../../../Core/Service/communicator-service';
import AppContext from '../../../../App/AppContext';
import formatters from '../../../../Core/Grid/inputFormatter';

const AddCheckIn = (props) => {
    const [form, setForm] = useState({
        tCardID: '',
        jobProgressDateArrived: '',
        errors: {}
    });

    const { showToast } = useContext(AppContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!form.jobProgressDateArrived) {
            errors.jobProgressDateArrived = 'Date is required';
            isValid = false;
        }

        setForm((prev) => ({ ...prev, errors }));
        return isValid;
    };

    const handleSubmit = async (e) => {
        if (validateForm()) {
            let res = await postTCard_CheckIn({
                tCardID: props.tCardsID,
                jobProgressDateArrived: form.jobProgressDateArrived
            });

            if (res.success) {
                showToast(res.message);
                props.onClose(true);
            } else {
                showToast(res.message);
                props.onClose(false);
            }
        }
    };

    return (
        <div>
            <Grid container spacing={2}>
                {!props.hideHeader && (
                    <>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Reg No</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.reg || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Customer</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.cust || 'N/A'}</div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Booking Date</div>
                            <div style={{ fontWeight: 'bold' }}>
                                {props.selectedVehicle?.bd ? formatters.MonthShortFormatter(props.selectedVehicle?.bd) : 'N/A'}
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ marginBottom: '5px' }}>Status</div>
                            <div style={{ fontWeight: 'bold' }}>{props.selectedVehicle?.status || 'N/A'}</div>
                        </Grid>
                    </>
                )}

                <Grid item xs={12}>
                    <InputLabel shrink error required>
                        Arrived Date
                    </InputLabel>
                    <TextBox
                        type="datetime-local"
                        name="jobProgressDateArrived"
                        value={form.jobProgressDateArrived}
                        variant="outlined"
                        fullWidth
                        onChange={handleChange}
                    />
                    <span className="mandatoryfields">{form.errors['jobProgressDateArrived']}</span>
                </Grid>

                <Grid item xs={12}>
                    <SecondaryButton className="Submitbtn" fullWidth onClick={handleSubmit}>
                        Submit
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default AddCheckIn;
